<div class="card-body border-top">
  <div class="row mb-4">
    <div class="col-2">
      <div class="form-group me-2">
        <select class="form-control" [(ngModel)]="years" (ngModelChange)="onYears($event)">
          <option [ngValue]="undefined" [selected]="!years" disabled>Select Years</option>
          <option *ngFor="let year of yearsCollection" [ngValue]="year.id">{{year.name}}</option>
        </select>
      </div>
    </div>
    <div class="col-8">
      <div class="form-group me-2">
        <jft-index-platts-select [buttonText]="'Show'" [clearSelected]="false"
          (onAdd)="addPlatts($event)"></jft-index-platts-select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-8">
      <div>
        <div *ngIf="loading" class="d-flex justify-content-center" style="position: absolute; top: 25%; left: 49%;">
          <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <jft-platts-chart [yearComparison]="yearComparison" [data]="onChartPlattsData">
        </jft-platts-chart>
      </div>
    </div>
    <div class="col-4">
      <div class="card bg-white">
        <!--                todo the same move to component-->
        <div class="card-header d-flex align-items-center justify-content-between">
          <h4 class="mb-0">Index Details</h4>
          <a class="pointer text-primary" (click)="resetGraph()">Clear All Indexes</a>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item media" *ngFor="let item of onChartPlattsData; let i = index">
            <div class="media-body">
              <a (click)="deleteGraph(i)" class="float-end">
                <i class="fas fa-trash pointer text-primary"></i>
              </a>
              <span class="float-start legend-label-color" [style.background-color]="getLabelColor(i)"></span>
              <h5 class="mt-0 mb-1">
                <span *ngIf="item.prices.length">{{ item.prices[0].date.slice(0, 4)}}</span>
                {{ item.platts_index.symbol }} {{ item.platts_index.description }} {{ item.bate.name }}
              </h5>
              Average price <strong>{{ item.average_price }}
                {{ item.currency_code }} / {{ item.unit_code }}</strong>
            </div>
          </li>
        </ul>
      </div>
      <div class="card bg-white mt-3">
        <ul id="index-list" class="list-group list-group-flush overflow-auto">
          <li class="list-group-item">
            <p class="fw-bold mb-0">Data Sources</p>
          </li>
          <li class="list-group-item">
            <a href="https://www.argusmedia.com/en/oil-products/argus-jet-fuel" target="_blank">
              <img src="../../../../../../assets/img/partners/argus-160x85.png" alt="Argus Media"
                class="analysis-partner-logo me-3">
            </a>
            <small>Copyright © 2022 <a href="https://www.argusmedia.com/en/oil-products/argus-jet-fuel"
                target="_blank">Argus
                Media</a> group. All
              rights reserved.</small>
          </li>
          <li class="list-group-item">
            <img src="../../../../../../assets/img/partners/graphs-SPG-Energy.png" alt="" class="analysis-partner-logo me-3">
            <small>S&P Global Energy, ©2022 by S&P Global Inc.</small>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
